import React from 'react';

import ProgramsHero from '@/components/04_templates/ProgramsPage/ProgramsHero';
import DynamicBreadcrumbs from '@/components/01_atoms/DynamicBreadcrumbs';
import VerticalTabs from '@/components/04_templates/ProgramsPage/VerticalTabs';
import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { getIndividualPageData, getPageInfo } from '@/api/global';

export async function getStaticProps() {
  let initialProps = {
    statusCode: 200,
  };

  try {
    const data = await getPageInfo('/programs');

    let node_data = null;
    if (data?.page?.entity) {
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
    }

    // Spread translate-path first, node_data last — node_data's status is the
    // real signal for whether the entity loaded.
    initialProps = { ...initialProps, ...(data || {}), ...(node_data || {}) };
    initialProps.statusCode =
      (node_data?.statusCode && node_data.statusCode >= 400) ? node_data.statusCode :
      (data?.statusCode || 200);
  }
  catch (e) {
    console.warn('Programs page retrieval error:', e);
    initialProps.statusCode = 500;
  }

  return {
    props: { ...initialProps },
    revalidate: 10800,
  };
}

export const useActionElementStyles = makeStyles((theme) => ({
  actionElement: {
    backgroundColor: '#3C8047 !important',
    color: '#fff !important',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    borderRadius: '0',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: 'rgb(42, 89, 49)',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      padding: '8px 16px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '6px 12px',
    },
  },
  container: {
    paddingLeft: '80px',
    paddingRight: '80px',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '40px',
      paddingRight: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
}));

function ProgramsPage(props) {
  const classes = useActionElementStyles();
  const node_data = props?.page_data || null;

  return (
    <div>
      <main>
        <ProgramsHero
          subtitle="  - Golf Programs -"
          title="at Baywood Greens"
          actionElement={
            <Button className={classes.actionElement} href='https://mailchi.mp/baywoodgreens.com/baywood-vip-list' target='_blank'>
              Subscribe to VIP newsletter
            </Button>
          }
        />

        <Box style={{ paddingLeft: '80px', paddingRight: '80px' }}>
          <DynamicBreadcrumbs />
          <VerticalTabs node={node_data} />
        </Box>
      </main>
    </div>
  );
}

export default ProgramsPage;
